import React, { Component } from 'react';
import './App.css';
import { Toolbar } from 'react-md';

import RobotCard from './components/robotcard';

import robotData from './data/robotdata';

class App extends Component {
  robotDataSorted = robotData.sort((a, b) => {
    if (a.group > b.group) return 1;
    if (a.group < b.group) return -1;
    if (a.name.toUpperCase() > b.name.toUpperCase()) return 1;
    if (a.name.toUpperCase() < b.name.toUpperCase()) return -1;
    else return 0;
  });

  robotList = this.robotDataSorted.map((robot) => (
    <RobotCard {...robot} key={robot.name} />
  ));

  render() {
    return (
      <div>
        <Toolbar
          title='The REDDIT Visual Guide'
          colored
        />
        <p style={{textAlign: 'center', padding: 10, fontStyle: 'italic'}}>Click on a robot for more information about it.</p>
        <div id='robot-container' style={{padding: 10}}>
          {this.robotList}
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js